import type { TeamRoles } from './rolesList';

export type SubscriptionSort = {
  direction: 'asc' | 'desc';
  property: string;
  ignoreCase: boolean;
  nullHandling: string;
  ascending: boolean;
  descending: boolean;
};

export type SubscriptionPageable = {
  pageNumber: number;
  pageSize: number;
  sort: SubscriptionSort[];
  offset: number;
  paged: boolean;
  unpaged: boolean;
};

export type SubscriptionContent = {
  channelIdentifier: string;
  clinicalTrialId: string;
  fullName: string;
  scope: string;
  subscribed: boolean;
  subscriptionId: string;
  subscriptionType: string;
  userId: string;
  // NOTE: User ids flagged as owners of this subscription. Returned by the GET
  // subscriptions endpoint and used to restore the "Set this subscriber as
  // owner" checkbox. The write path sends these under `filter.owners` instead.
  owners?: string[];
};

export type SubscriptionResponse = {
  content: SubscriptionContent[];
  pageable: SubscriptionPageable;
  last: boolean;
  totalPages: number;
  totalElements: number;
  size: number;
  number: number;
  sort: SubscriptionSort[];
  first: boolean;
  numberOfElements: number;
  empty: boolean;
};

export type Subscription = {
  id: string;
  subscriptionId: string;
  userId: string;
  clinicalTrialId: string;
  user: {
    firstName: string;
    lastName: string;
    fullName: string;
  };
  channelUserIdentifier: string;
  channelType: string;
  notificationType: NotificationTypes;
  filter?: {
    sites?: string[];
  };
  subscribed: boolean;
};

export type PMSubscription = {
  id: string;
  userId: string;
  clinicalTrialId: string;
  fullName: string;
  channelIdentifier: string;
  subscriptionType: string;
  scope: string;
  subscribed: boolean;
};

export enum NotificationTypes {
  UPLOAD_COMPLETED = 'UPLOAD_COMPLETED',
  READY_FOR_READING = 'READY_FOR_READING',
  VISIT_COMPLETED = 'VISIT_COMPLETED',
  READING_COMPLETED = 'READING_COMPLETED',
  REPORT_RELEASED = 'REPORT_RELEASED',
  SUBJECT_COMPLETED = 'SUBJECT_COMPLETED',
  VALIDATION_COMPLETED = 'VALIDATION_COMPLETED',
  QUERY_NOTIFICATION = 'QUERY_NOTIFICATION',
}

export const notificationTypesReadable = {
  [NotificationTypes.UPLOAD_COMPLETED]: 'Upload Completed',
  [NotificationTypes.READY_FOR_READING]: 'Ready for Reading',
  [NotificationTypes.VISIT_COMPLETED]: 'Visit Completed',
  [NotificationTypes.READING_COMPLETED]: 'Reading Completed',
  [NotificationTypes.REPORT_RELEASED]: 'Report Released',
  [NotificationTypes.SUBJECT_COMPLETED]: 'Subject Completed',
  [NotificationTypes.VALIDATION_COMPLETED]: 'Validation Completed',
  [NotificationTypes.QUERY_NOTIFICATION]: 'Query Notification',
};

export type RoleNotificationSettings = {
  [K in NotificationTypes]: boolean;
};

export type RoleNotifications = {
  [R in TeamRoles]: RoleNotificationSettings;
};

export type NotificationsData = {
  roleNotifications: RoleNotifications;
};
